import React, { useState } from "react";
import { Select, Typography } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import * as pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css"; // Importation des styles du plugin

const { Option } = Select;
const { Title } = Typography;
const FileSelector = ({ pdfFiles, selectedFile, onFileChange }) => (
  <Select
    style={{ width: 600, marginBottom: 16 }}
    placeholder="Sélectionner un fichier PDF"
    onChange={onFileChange}
    value={selectedFile}
  >
    {pdfFiles.map((file, index) => (
      <Option key={index} value={file.file}>
        {file.name}
      </Option>
    ))}
  </Select>
);

const PdfViewer = ({ file }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  try {
    return (
      <div style={{height:"700px"}}>
        <Worker workerUrl={pdfjsWorker}>
          <Viewer fileUrl={file} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      </div>
    );
  } catch (error) {
    console.error("Erreur lors du chargement du PDF:", error);
    return <div>Erreur lors du chargement du PDF. Veuillez réessayer.</div>;
  }
};

// Convertit un nom de fichier en libellé lisible (ex: "PLAN COMPTABLE SYSCOHADA" -> "Plan Comptable Syscohada")
const formatFileLabel = (fileName) => {
  const baseName = fileName.replace(/\.pdf$/i, "").trim();
  if (baseName !== baseName.toUpperCase()) return baseName;
  return baseName
    .toLowerCase()
    .replace(/(^|[\s'-])\S/g, (char) => char.toUpperCase());
};

// Lit directement le contenu du dossier Pdf (webpack liste les fichiers au build)
const pdfContext = require.context("./Pdf", false, /\.pdf$/i);
const pdfFiles = pdfContext
  .keys()
  .map((key) => ({
    name: formatFileLabel(key.replace("./", "")),
    file: pdfContext(key),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

const TextReglement = () => {
  const [selectedFile, setSelectedFile] = useState(pdfFiles[0].file);

  const handleFileChange = (value) => {
    setSelectedFile(value);
  };

  return (
    <div style={{ padding: 12 }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 20px",
        background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
        borderRadius: 10,
        boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
        marginBottom: 16,
      }}
    >
      <FileTextOutlined style={{ fontSize: 22, color: "#fff" }} />
      <span
        style={{
          fontSize: 18,
          fontWeight: 600,
          color: "#fff",
          letterSpacing: 0.5,
          margin: 0,
        }}
      >
        Texte & Réglements
      </span>
    </div>
      <FileSelector pdfFiles={pdfFiles} selectedFile={selectedFile} onFileChange={handleFileChange} />
      <PdfViewer file={selectedFile} />
    </div>
  );
};

export default TextReglement;
